import { render, staticRenderFns } from "./FileDropZone.vue?vue&type=template&id=059581f4"
import script from "./FileDropZone.vue?vue&type=script&lang=js"
export * from "./FileDropZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports